/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { styled, use } from 'fierry/react';

import Route from 'solis/route';
import Galaxy from 'solis/application/galaxy';

import * as Board from 'solis/react/board';

import Autosize from 'solis/react/element/autosize';

import BoardData from 'solis/react/board/data/board';
import StyledData from 'solis/react/board/data/styled';
import ZoneSelection from 'solis/react/board/selection/zone';

import FutureColonyEmphasis from 'solis/react/board/emphasis/future.colony';
import ColonyInfluenceEmphasis from 'solis/react/board/emphasis/colony.influence';
import NotEmphasis from 'solis/react/board/emphasis/not';
import NoneEmphasis from 'solis/react/board/emphasis/none';

import Args from 'solis/claude/action/args';
import useSourceColony from 'solis/claude/action/source.colony';


const SETTINGS = { ...Board.Interactive, selection: new ZoneSelection(Args.BoardZone) };


const StyledBoard = styled(Board.WithData)`

  display: block;
`;


const createData = (board, sourceColony) =>
{
  const emphasis = new FutureColonyEmphasis(sourceColony !== null ? sourceColony.cass.id : null);
  const dimming = sourceColony !== null ? new NotEmphasis(new ColonyInfluenceEmphasis(board, sourceColony)) : new NoneEmphasis();

  const boardData = new BoardData({ board, sourceColony });

  return new StyledData({ data: boardData, emphasis, dimming });
};


export default () =>
{
  const route = use(Route);
  const galaxy = use(Galaxy);

  const board = galaxy.getBoard(route.getArg('id'));
  const account = galaxy.getCurrentAccount();

  const sourceColony = useSourceColony(board, account);

  const data = createData(board, sourceColony);

  return <Autosize component = {StyledBoard} data = {data} zoom = {3} settings = {SETTINGS} />;
};
